import Skeleton from 'react-loading-skeleton';
import Fade from 'react-reveal/Fade';
import { useSite } from '../context/SiteContext';
import { envConfig } from '../utils/envConfig';

export default function EcosystemSection() {
  const { ecosystem, loading } = useSite();
  const displayEcosystem = (ecosystem || []).filter(item =>
    !item.title?.toLowerCase().includes('wayapos') &&
    !item.title?.toLowerCase().includes('waya pos')
  );

  const getLink = (item) => {
    switch (item.type) {
      case 'gram':
        return envConfig.gramUrl;
      case 'pay':
        return envConfig.wayapayUrl;
      case 'pos':
        return envConfig.posUrl;
      default:
        return item.cardLink;
    }
  };
  return (
    <section id="ecosystem" className="waya-ecosystem-wrapper py-5">
      <div className="container">
        <div className="text-center mb-5">
          <Fade bottom>
            <h6 className="waya-section-badge mx-auto">WayaLinks Mission</h6>
            <h2 className="waya-section-title mt-3">
              Banking the Unbanked, One Account at a Time
            </h2>
            <p className="waya-section-subtitle mx-auto" style={{ maxWidth: '800px' }}>
              WayaBank is part of <a href="https://wayalinks.com" target="_blank" rel="noreferrer" style={{ color: 'var(--waya-primary)', fontWeight: '700', textDecoration: 'none' }}>WayaLinks</a> — a Nigerian-built technology ecosystem connecting people, businesses, and communities to the digital economy.
            </p>
          </Fade>
        </div>

        <div className="waya-ecosystem-restructured" style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
          gap: '60px',
          marginTop: '80px',
          padding: '0 4%'
        }}>
          {loading
            ? [1, 2, 3].map((i) => (
              <div key={i} className="text-center">
                <Skeleton count={3} height={14} className="mb-4" />
                <Skeleton height={40} width={120} className="mx-auto" />
              </div>
            ))
            : displayEcosystem.map((item, index) => (
              <Fade bottom delay={index * 100} key={index}>
                <div className="ecosystem-item-modern" style={{
                  textAlign: 'center',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  padding: '0 20px'
                }}>
                  <div
                    className="ecosystem-logo-wrap"
                    style={{
                      height: '60px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      cursor: 'pointer',
                      transition: 'transform 0.3s ease'
                    }}
                    onClick={() => window.open(getLink(item), '_blank')}
                    onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.1)'}
                    onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                  >
                    <img
                      src={item.image_url}
                      alt={item.title}
                      style={{
                        maxHeight: '100%',
                        maxWidth: '160px',
                        objectFit: 'contain',
                        filter: 'grayscale(0.2) opacity(0.8)',
                        transition: 'filter 0.3s ease'
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.filter = 'grayscale(0) opacity(1)';
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.filter = 'grayscale(0.2) opacity(0.8)';
                      }}
                    />
                  </div>
                </div>
              </Fade>
            ))}
        </div>
      </div>
    </section>
  );
}
